// extracted by mini-css-extract-plugin
export default {"footerWrap":"styles_footerWrap__JOKwK","sendAgain":"styles_sendAgain__C4pRg"};